<template>
  <div style="width: 100%; height: 100%; overflow:hidden;">
    <div style="width: 99.5%; height: 99%; overflow:auto; background-color: yellow;">
      <div style="width: 100%; height: 10%; background-color: black; color: #ffffff; font-size: 22px">气象实时数据 </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PestTrendData'
  }
</script>



// WEBPACK FOOTER //
// src/components/view/PestTrendData.vue